module.exports = __webpack_public_path__ + "static/media/nasa.ee15e8fa.svg";